module.exports = __webpack_public_path__ + "static/img/portrait.c7c5075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portrait.jpg
// module id = 4/ss
// module chunks = 102